module.exports = __webpack_public_path__ + "media/images/cardboard-img-10-520336b0c265b50f650cb22eb9ccc074.jpg";